import { AbstractControl, ValidationErrors } from '@angular/forms';

export function phoneValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value?.trim();
  if (!value) return null;
  const phonePattern = /^\+?[0-9]{1,4}[\s]?[0-9]{6,14}$/;
  const valid = phonePattern.test(value);
  return valid ? null : { phone: true };
}

export function emailValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value == '' || control.value == undefined || control.value == null) return { email: true };
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const valid = emailPattern.test(control.value);
  return !valid ? null : { email: true };
}
export function linkValidator(control: AbstractControl): boolean {
  const value = control.value?.trim();

  if (!value) return true;

  // URL pattern più rigoroso che richiede protocollo o www e un dominio valido
  const urlPattern = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z]{2,}\b([-a-zA-Z0-9()@:%_\+.~#?&\/\/=]*)$/;

  // Verifica anche che il dominio abbia almeno 1 carattere prima del punto e 2 dopo (consente domini tipo x.com)
  const hasValidDomain = /[-a-zA-Z0-9]{1,}\.[a-zA-Z]{2,}/.test(value);

  return urlPattern.test(value) && hasValidDomain;
}

export function mustBeChecked(control: AbstractControl): ValidationErrors | null {
  return control.value === true ? { mustBeChecked: true } : null;
}

